module.exports = __webpack_public_path__ + "media/country_flags/dm-5966ac35.png";